import React, { useState, useEffect } from "react";
import { ThemeProvider } from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";

//import DataTable from './DataTable';
//import PlannedIdleTime from './PlannedIdleTime';
//import UnplannedIdleTime from './UnplannedIdleTime';
//import IHFTime from './IHFTime';
import { lightTheme } from "../../SharedComponents/SharedComponentStyles";
import axios from "axios";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import CircularProgress from "@material-ui/core/CircularProgress";
import Alert from "@material-ui/lab/Alert";
//Autocomplete
import Autocomplete from "@material-ui/lab/Autocomplete";
import MaterialTable from "material-table";
//import { tableOptionsUser } from "../../SharedComponents/SharedComponentStyles";
import { forwardRef } from "react";
import {
  AddBox,
  Check,
  DeleteOutline,
  Edit,
  SaveAlt,
  FilterList,
  FirstPage,
  LastPage,
  ChevronRight,
  ChevronLeft,
  Clear,
  Search,
  ArrowDownward,
  Remove,
  ViewColumn,
} from "@material-ui/icons";
import { useSelector, useDispatch } from "react-redux";

const api = axios.create({
  baseURL: "InventoryAudit",
});

const apiSlip = axios.create({
  baseURL: "SlipGeneration",
});
const apiPlant = axios.create({
  baseURL: "InventoryMasterDetails",
});

export const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => (
    <DeleteOutline {...props} ref={ref} style={{ color: "var(--red)" }} />
  )),
  DetailPanel: forwardRef((props, ref) => (
    <ChevronRight {...props} ref={ref} />
  )),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => (
    <ChevronLeft {...props} ref={ref} />
  )),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => (
    <Search {...props} ref={ref} style={{ fontSize: "2.5rem" }} />
  )),
  SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
};
//const useStyles = makeStyles((theme: Theme) =>
//    createStyles({
//        container: {
//            display: 'flex',
//            flexWrap: 'wrap',
//        },
//    }),
//);
const data = [
  {
    id: "12345678",
    firstName: "0001-HFHJS",
    lastName: "16.5",
    emailId: "sriyanka",
    phone: "9/01/2023  10:12:23",
  },
];

export default function AuditInventory(props) {
  //const classes = useStyles();

  //for progress
  var columns = [
    { title: "Slip Number", field: "id" },
    { title: "Location", field: "firstName" },
    { title: "Entered Quantity", field: "lastName" },
    { title: "Entered By", field: "emailId" },
    { title: "Entered On", field: "phone" },
  ];

  const [openLoader, setopenLoader] = useState(false);

  //for Warning showing
  const [openWarning, setopenWarning] = useState(false);
  const [openAlertWarning, setopenAlertWarning] = useState("");
  const [openClassNameWarning, setopenClassNameWarning] = useState("");
  const [openTypeWarning, setopenTypeWarning] = useState("");
  const [alertwarningclass, setalertwarningclass] =
    useState("bg-amber clr-white");
  const [alertwarning, setalertwarning] = useState("Warning");

  //for error handling
  const [iserror, setIserror] = useState(false);
  const [errorMessages, setErrorMessages] = useState([]);
  const [severity, setSeverity] = useState("success");

  //Autocomplete
  const [employeeObj, setEmployeeObj] = useState("");
  const [employeeText, setEmployeeText] = useState("");
  const token = useSelector((state) => state.saveAzureTokenReducer.token);
  const userDetails = useSelector(
    (state) => state.storeUserDetailsReducer.userData
  );
  const bearerToken = useSelector(
    (state) => state.saveBearerTokenReducer.bearerToken
  );
  const uId = useSelector((state) => state.saveUIDReducer.uid);

  const handleChangeEmployee = (event, newValue) => {
   // console.log(newValue);
    setEmployeeObj(newValue ? newValue : []);
    setEmployeeText(newValue ? newValue.empName : "");
    setemployeeValue(newValue ? newValue.employeeId : 0);
  };
  const handleChangeEmployeeInput = (event, newInputValue) => {
    setEmployeeText(newInputValue ? newInputValue : " ");
  };

  const handleErrorClose = (e) => {
    setIserror(false);
  };

  function handleCloseWarning() {
    setopenWarning(false);
  }

  //function getURLParameter(sParam) {
  //    var sPageURL = window.location.search.substring(1);
  //    var sURLVariables = sPageURL.split('&');
  //    for (var i = 0; i < sURLVariables.length; i++) {
  //        var sParameterName = sURLVariables[i].split('=');
  //        var value = '';
  //        for (var j = 0; j < sParameterName.length; j++) {
  //            if (sParameterName[j] == sParam) {
  //                for (var k = j + 1; k < sParameterName.length; k++) {
  //                    value = value + sParameterName[k];
  //                }
  //                break;
  //            }
  //            else {
  //                continue;
  //            }
  //        }
  //        return value;
  //    }
  //}
  const tableHeaderStyle = {
    backgroundColor: "var(--light-sand)",
    color: "var(--dark-blue)",
  };
  const tableOptions = {
    headerStyle: tableHeaderStyle,
    showTitle: false,
    draggable: false,
    pageSize: 5,
    pageSizeOptions: [5, 10, 25, 50],
    paginationPosition: "bottom",
    //paging: false,
    maxBodyHeight: "600px",
    // exportButton: true,
    // exportAllData: true
  };
  function getURLParameter(sParam) {
    var sPageURL = window.location.search.substring(1);
    var sURLVariables = sPageURL.split("&");
    for (var i = 0; i < sURLVariables.length; i++) {
      var sParameterName = sURLVariables[i].split("=");
      var value = getParamName(sParameterName, sParam);
      return value;
    }
  }

  function getParamName(sParameterName, sParam) {
    var value = "";
    for (var j = 0; j < sParameterName.length; j++) {
      if (sParameterName[j] == sParam) {
        value = value + getParanValue(j, sParameterName);
        break;
      } else {
        continue;
      }
    }
    return value;
  }

  function getParanValue(j, sParameterName) {
    var value = "";
    for (var k = j + 1; k < sParameterName.length; k++) {
      value = value + sParameterName[k];
    }
    return value;
  }

  const today = Date.now();
  let newdateformat = new Intl.DateTimeFormat("en-US", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(today);
  let ldate =
    newdateformat.split("/")[2] +
    "-" +
    newdateformat.split("/")[0] +
    "-" +
    newdateformat.split("/")[1];
  const [entrydate, setentrydate] = useState(ldate);
  const [isDisabled, setisDisabled] = useState(true);
  const [employee, setemployee] = useState([]);
  const [employeeValue, setemployeeValue] = useState("");
  //const [employeeNameValue, setEmployeeNameValue] = useState("");
  //const [employeeNames, setEmployeeNames] = useState([]);
  const [mrp, setmrp] = useState([]);
  const [time, settime] = useState([]);
  const [date, setdate] = useState([]);
  const [mrpValue, setmrpValue] = useState("");
  const [shiftValue, setshiftValue] = useState("");
  const [slipGenId, setslipGenId] = useState(
    window.atob(getURLParameter("ID"))
      ? window.atob(getURLParameter("ID"))
      : props.SlipGenId
  );
  const [EntryNumberValue, setEntryNumberValue] = useState("");
  const [ViewEntryNumberValue, setViewEntryNumberValue] = useState("");
  const [WorkerShift, setWorkerShift] = useState([]);
  const [EnteredTimeValue, setEnteredTimeValue] = useState("");
  const [InputTimeValue, setInputTimeValue] = useState("");
  const [IdleTimeValue, setIdleTimeValue] = useState("");
  const [EfficiencyValue, setEfficiencyValue] = useState("");
  const [slipDataDetails, setslipDataDetails] = useState([]);
  const [slipDataPlanTime, setslipDataPlanTime] = useState([]);
  const [slipDataUnPlanTime, setslipDataUnPlanTime] = useState([]);
  const [slipDataIHFTime, setslipDataIHFTime] = useState([]);
  const [PlanTimeValue, setPlanTimeValue] = useState([]);
  const [UnPlanTimeValue, setUnPlanTimeValue] = useState([]);
  const [IHFTimeValue, setIHFTimeValue] = useState([]);
  const [NoWorkValue, setNoWorkValue] = useState(0);
    const [CreatedBy, setCreatedBy] = useState(
        props.loginuser.response.firstName + " " + props.loginuser.response.lastName
  );
  const [CreatedUserId, setCreatedUserId] = useState(
      props.loginuser.response.employeeId
  );
  const [isSubmitDisabled, setisSubmitDisabled] = useState(true);
  const [ViewEfficiencyValue, setViewEfficiencyValue] = useState("");
  const [open, setopen] = useState(false);
  const [openAlert, setopenAlert] = useState("");
  const [openClassName, setopenClassName] = useState("");
  const [openType, setopenType] = useState("");
  //const [alertsuccess, setalertsuccess] = useState("Success");
  //const [alerterror, setalerterror] = useState("Alert");
  //const [alertsuccessclass, setalertsuccessclass] = useState("bg-light-green clr-white");
  //const [alerterrorclass, setalerterrorclass] = useState("bg-red clr-white");
  //new
  const [Remarks, setRemarks] = useState("");
  const [place, setPlace] = useState([]);
  const [placeValue, setPlaceValue] = useState("");
  const [loc, setLoc] = useState("");
  const [matNo, setMatNo] = useState("");
  const [matDesc, setMatDesc] = useState("");
  const [classification, setClassification] = useState("");
  const [unit, setUnit] = useState("");
  const [physical, setPhysical] = useState("");
  const [MeasuringUnit, setMeasuringUnit] = useState("");
  const [CountedBy, setCountedBy] = useState("");
  const [MismatchQty, setMismatchQty] = useState("");
  const [AuditedQty, setAuditedQty] = useState("");
  const [AuditedBy, setAuditedBy] = useState("");
  //PLANT NAME
  const [plant, setPlant] = useState([]);
  const [plantData, setPlantData] = useState("");

  //new handles for slip
  const [phyInvSlipNum, setphyInvSlipNum] = useState("");
  const [phyInvSlipID, setphyInvSlipID] = useState("");
  const [phyInvSlipObj, setphyInvSlipObj] = useState([]);
  const [phyInvAllSlip, setphyInvAllSlip] = useState([]);
  const [phyInvSlipDetails, setphyInvSlipDetails] = useState([]);
  const [canShowHelperText, setCanShowHelperText] = useState(false);

  const handleChangephyInvSlipNum = async (event, newValue) => {
    setphyInvSlipObj(newValue ? newValue : []);
    setphyInvSlipNum(newValue ? newValue.slipnumber : "");
    setphyInvSlipID(newValue ? newValue.slipId : 0);
    await BindSlipDetails(newValue ? newValue.slipId : 0);
  };
  async function BindSlipDetails(slipId) {
      setopenLoader(true);
      let slipIdData = {
          slipid: slipId
      }
      const options = {
          headers: {
              Authorization: "Bearer " + bearerToken,
              UserEmail: userDetails.emailId,
              userId: uId,
              RoleName: userDetails.roleName,
              Gid: userDetails.gid,
              Roleid: userDetails.roleId,
              //AzureToken: token,
          },
    };
   await api
       .post("/getPhyInvSlipDetails/", slipIdData,options)
      .then((res) => {
       // console.log("res", res);
        setphyInvSlipDetails(res.data);
        setPlaceValue(res.data[0].plantname);
        setMatNo(res.data[0].materialName);
        setMatDesc(res.data[0].materialDescription);
        setClassification(res.data[0].abcclassiification);
        setPhysical(res.data[0].countedPhyQuantity);
        setMeasuringUnit(res.data[0].unitOfMeasurement);
        setCountedBy(res.data[0].slipCreatedBy);
        setAuditedBy(CreatedBy);
        setopenLoader(false);
      })
      .catch((error) => {
        console.log("Error in hitting api at page load. PhyInvLocation");
        setopenLoader(false);
      });
  }

  const handleChangephyInvSlipNumInput = (event, newInputValue) => {
   // console.log("newInputValue", newInputValue);
    setphyInvSlipNum(newInputValue ? newInputValue : "");
  };
  const handlePlace = (event) => {
    setPlaceValue(event.target.value);
  };

  const handleRemarksChange = (event) => {
    setRemarks(event.target.value);
  };
  const handleLoc = (event) => {
    setLoc(event.target.value);
  };
  const handleMatNo = (event) => {
    setMatNo(event.target.value);
  };
  const handleMatDesc = (event) => {
    setMatDesc(event.target.value);
  };
  const handleClassification = (event) => {
    setClassification(event.target.value);
  };
  const handleUnit = (event) => {
    setUnit(event.target.value);
  };
  const handlePhysical = (event) => {
    setPhysical(event.target.value);
  };

  const handleMismatchQty = (event) => {
    setMismatchQty(event.target.value);
  };
  function getPlant(ID) {
   // console.log("id", ID);
    const headers = {
      Authorization: "Bearer " + bearerToken,
      UserEmail: userDetails.emailId,
      userId: uId,
      RoleName: userDetails.roleName,
      Gid: userDetails.gid,
      Roleid: userDetails.roleId,
      //AzureToken: token,
    };
    setopenLoader(true);
    apiPlant
      .get("/getTblMstPlant/" + ID, {
        headers: headers,
      })
      .then((res) => {
       // console.log("plantdata", res.data);
        setPlant(res.data);
        setopenLoader(false);
      })
      .catch((error) => {
        console.log("Error in hitting api at page load. MRP Controller");
        setopenLoader(false);
      });
  }
  const handlePlant = (e) => {
   // console.log("aaa", e.target.value);
    setPlantData(e.target.value);
    getWorkflowstatusforaudit(e.target.value);
    getSlipNumber(e.target.value);
  };

  function clearPlant() {
    setPlantData();
  }
  useEffect(() => {
    getPlant(props.loginuser.response.gid);
  }, []);
  const handleAuditedQty = (event) => {
    const regexp = /^(([0-9]{0,7})(\.[0-9]{0,5})?|10000000)$/;
    if (event.target.value === "" || regexp.test(event.target.value)) {
      setCanShowHelperText(true);
      setAuditedQty(event.target.value);
      var auditedQty = event.target.value;
      var countedqty = physical;
      var mismatchQty = auditedQty - countedqty;
      setMismatchQty(mismatchQty);
    } else {
      setCanShowHelperText(false);
    }
  };

  const handleMeasuringUnit = (event) => {
    setMeasuringUnit(event.target.value);
  };
  const handleCountedBy = (event) => {
    setCountedBy(event.target.value);
  };
  const handleAuditedBy = (event) => {
    setAuditedBy(event.target.value);
  };

  //const handleChangeEmp = (event) => {
  //    setemployeeValue(event.target.value);
  //};

  const handleChangeMrp = (event) => {
    setmrpValue(event.target.value);
  };

  const handleChangeShift = (event) => {
    setshiftValue(event.target.value);
  };

  function handleClose() {
    setopen(false);
  }

  //NEW FUNCS
  function clear() {
    setphyInvSlipNum("");
    setphyInvSlipID("");
    setphyInvSlipObj([]);
    setPlaceValue("");
    setPhysical("");
    setRemarks("");
    setMeasuringUnit("");
    setCountedBy("");
    setMismatchQty("");
    setAuditedQty("");
    setAuditedBy("");
    setMatNo("");
    setMatDesc("");
    setClassification("");
  }

  //useEffect(() => {
  //    getSlipNumber();

  //}, []);
  async function getSlipNumber(plantId) {
    let errorList = [];
    const headers = {
      Authorization: "Bearer " + bearerToken,
      UserEmail: userDetails.emailId,
      userId: uId,
      RoleName: userDetails.roleName,
      Gid: userDetails.gid,
      Roleid: userDetails.roleId,
      //AzureToken: token,
    };
   // console.log("plantidfromslip", plantId);
    setopenLoader(true);
    await api
      .get("/getSlipNumber/" + plantId,{
        headers: headers
      })
      .then((res) => {
      //  console.log("res.data", res.data);
        if (res.data.length <= 0) {
          //clearPlant();
          errorList.push("This plant has no active workflow");
          showMessage(errorList, true, "error");
          setPlantData("");
        }
        setphyInvAllSlip(res.data);
        setopenLoader(false);
      })
      .catch((error) => {
        console.log("Error in hitting api at page load. MRP Controller");
        setopenLoader(false);
      });
  }
  const [statusAudit, setStatusAudit] = useState("");
  async function getWorkflowstatusforaudit(plantId) {
    let response = [];
    let errorList = [];

    setopenLoader(true);
    const headers = {
      Authorization: "Bearer " + bearerToken,
      UserEmail: userDetails.emailId,
      userId: uId,
      RoleName: userDetails.roleName,
      Gid: userDetails.gid,
      Roleid: userDetails.roleId,
      //AzureToken: token,
    };
    await api
      .get("/workflowstatusforaudit/" + plantId,{headers: headers})
      .then((result) => {
        response = result.data;
       // console.log("response123", response);
        if (response.result.objResult.length > 0) {
          setopenLoader(false);
          setStatusAudit(response.result.objResult[0].workflow);
        } else {
          // clearPlant();
          setopenLoader(false);
          errorList.push(
            "Slips cannot be Audited as workflow date has been expired!!!"
          );
          showMessage(errorList, true, "error");
          setPlantData("");
        }
      })
      .catch((error) => {
        console.log("Error : ", error);
        setopenLoader(false);
        errorList.push("Something went wrong!");
        showMessage(errorList, true, "error");
        //clearSpecific();
      });
  }
  async function submitSlip() {
    let isValidate = true;
    const headers = {
      Authorization: "Bearer " + bearerToken,
      UserEmail: userDetails.emailId,
      userId: uId,
      RoleName: userDetails.roleName,
      Gid: userDetails.gid,
      Roleid: userDetails.roleId,
      //AzureToken: token,
    };
    let errorList = [];
    if (
      phyInvSlipNum == "" ||
      phyInvSlipNum === null ||
      phyInvSlipNum === undefined
    ) {
      isValidate = false;
      errorList.push("Select Slip Number");
      showMessage(errorList, true, "error");
    }
    if (AuditedQty == "" || AuditedQty === null || AuditedQty === undefined) {
      isValidate = false;
      errorList.push("Enter Audited Quantity");
      showMessage(errorList, true, "error");
    }
    //if (Remarks == "" || Remarks === null || Remarks === undefined) {
    //    isValidate = false;
    //    //showMsg(true, "Select Entry Date.", alerterrorclass, alerterror);
    //    errorList.push("Enter Remarks");
    //    showMessage(errorList, true, 'error');
    //}

    if (isValidate) {
      setopenLoader(true);
      let slipData = {
        SlipId: phyInvSlipID,
        AuditedBy: CreatedUserId,
        AuditedQuantity: Number(AuditedQty),
        MismatchQuantity: Number(MismatchQty),
        CreatedBy: CreatedUserId,
        Remarks: Remarks,
      };
     // console.log("slipData", slipData);
      //let errorList = [];
      await api
        .post("/SaveAuditPhyInvSlip/", slipData,{headers: headers})
        .then((res) => {
        //  console.log("savedata", res.data);
          setopenLoader(false);
          errorList.push(
            "Entry Number A" +
              res.data.result.auditSlipNumber +
              " submitted successfully."
          );
          showMessage(errorList, true, "success");
          //getSlipNumber();
          clear();
        })
        .catch((error) => {
          setopenLoader(false);
        });
    }
  }
  function showMessage(errorList, flag, severity) {
    setErrorMessages(errorList);
    setIserror(flag);
    setSeverity(severity);
  }

  return (
    <ThemeProvider theme={lightTheme}>
      <div className="master-layout-data">
        <Box paddingTop={{ xs: "5rem", sm: "2rem" }} className="">
          <h3 className="clr-dark-blue d-flex jc-center mt-2 mb-1">
            New Audit Slip
          </h3>
        </Box>
        <Grid
          container
          spacing={2}
          className="d-flex mt-1 fd-row mb-1 px-1 box-shadow width-100 bdr-radius "
        >
          <Grid item xs={12} sm={12} className="userManagement mt-1 mb-1">
            <div>
              {iserror && (
                <Alert severity={severity} onClose={handleErrorClose}>
                  {errorMessages.map((msg, i) => {
                    return <div key={i}>{msg}</div>;
                  })}
                </Alert>
              )}
            </div>
          </Grid>

          <Grid item xs={12} sm={3} className="d-flex Width-100 mt-1">
            <TextField
              className="lightInputFields  "
              select
              id=""
              //disabled={true}
              label="Plant Name"
              variant="filled"
              fullWidth
              name=""
              value={plantData}
              onChange={handlePlant}
            >
              {plant.map((h, i) => (
                <MenuItem key={i} value={h.plantId}>
                  {h.plantName}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={12} sm={3} className="d-flex Width-100 mt-1">
            <Autocomplete
              className="lightInputFields"
              //disablePortal
              id="combo-box-demo"
              value={phyInvSlipObj}
              inputValue={phyInvSlipNum}
              options={phyInvAllSlip}
              getOptionLabel={(option) =>
                option.slipnumber ? option.slipnumber : ""
              }
              onChange={handleChangephyInvSlipNum}
              onInputChange={handleChangephyInvSlipNumInput}
              // sx={{ width: 300 }}
              renderInput={(params) => (
                <TextField {...params} label="Slip Number" />
              )}
            />
            {/*    <TextField className="lightInputFields  "*/}
            {/*        select*/}
            {/*        id=""*/}
            {/*        //disabled={true}*/}
            {/*        label="Slip Number"*/}
            {/*        variant="filled"*/}
            {/*        fullWidth*/}
            {/*        name=""*/}
            {/*        value={placeValue}*/}
            {/*        onChange={handlePlace}*/}
            {/*    >*/}
            {/*        <MenuItem value="">*/}
            {/*            <em>Select</em>*/}
            {/*        </MenuItem>*/}
            {/*        <MenuItem value={10}>Ten</MenuItem>*/}
            {/*        <MenuItem value={20}>Twenty</MenuItem>*/}
            {/*        <MenuItem value={30}>Thirty</MenuItem>*/}
            {/*    </TextField>*/}
          </Grid>

          <Grid item xs={12} sm={3} className="d-flex Width-100  mt-1">
            <TextField
              className="lightInputFields  "
              //id="createdBy"
              disabled={true}
              label="Material Number"
              variant="filled"
              fullWidth
              //name="Created By"
              value={matNo}
              onChange={handleMatNo}
            >
              {/*<MenuItem value="">*/}
              {/*    <em>Select</em>*/}
              {/*</MenuItem>*/}
              {/*<MenuItem value={10}>Ten</MenuItem>*/}
              {/*<MenuItem value={20}>Twenty</MenuItem>*/}
              {/*<MenuItem value={30}>Thirty</MenuItem>*/}
            </TextField>
          </Grid>
          <Grid item xs={12} sm={3} className="d-flex Width-100 mt-1">
            <TextField
              className="lightInputFields"
              //id="CreatedTime"
              disabled={true}
              label="Material Description"
              variant="filled"
              fullWidth
              //name="Created Time"
              value={matDesc}
              onChange={handleMatDesc}
            />
          </Grid>
          <Grid item xs={12} sm={3} className="d-flex Width-100 mt-1">
            <TextField
              className="lightInputFields"
              //id="CreatedTime"
              disabled={true}
              label="ABC Classification"
              variant="filled"
              fullWidth
              //name="Created Time"
              value={classification}
              onChange={handleClassification}
            />
          </Grid>

          <Grid item xs={12} sm={3} className="d-flex Width-100 mt-1">
            <TextField
              className="lightInputFields"
              //id="inputTime"
              disabled={true}
              label="Counted Physical Quantity"
              variant="filled"
              fullWidth
              // name="Input Time"
              value={physical}
              onChange={handlePhysical}
            />
          </Grid>
          <Grid item xs={12} sm={3} className="d-flex Width-100 mt-1">
            <TextField
              className="lightInputFields"
              //id="inputTime"
              //disabled={true}
              label="Audited Quantity"
              helperText={
                canShowHelperText
                  ? ""
                  : "Please enter only numbers from 0 to 1Crore"
              }
              variant="filled"
              fullWidth
              // name="Input Time"
              value={AuditedQty}
              onChange={handleAuditedQty}
            />
          </Grid>
          <Grid item xs={12} sm={3} className="d-flex Width-100 mt-1">
            <TextField
              className="lightInputFields"
              //id="inputTime"
              disabled={true}
              label="Mismatch Quantity"
              variant="filled"
              fullWidth
              // name="Input Time"
              value={MismatchQty}
              onChange={handleMismatchQty}
            />
          </Grid>

          <Grid item xs={12} sm={3} className="d-flex Width-100 mt-1">
            <TextField
              className="lightInputFields"
              //id="inputTime"
              disabled={true}
              label="Measuring Unit"
              variant="filled"
              fullWidth
              // name="Input Time"
              value={MeasuringUnit}
              onChange={handleMeasuringUnit}
            />
          </Grid>
          <Grid item xs={12} sm={3} className="d-flex Width-100 mt-1">
            <TextField
              className="lightInputFields"
              //id="inputTime"
              disabled={true}
              label="Counted By"
              variant="filled"
              fullWidth
              // name="Input Time"
              value={CountedBy}
              onChange={handleCountedBy}
            />
          </Grid>
          <Grid item xs={12} sm={3} className="d-flex Width-100 mt-1">
            <TextField
              className="lightInputFields"
              //id="inputTime"
              disabled={true}
              label="Audited By"
              variant="filled"
              fullWidth
              // name="Input Time"
              value={AuditedBy}
              onChange={handleAuditedBy}
            />
          </Grid>
          <Grid item xs={12} sm={6} className="d-flex Width-100 mt-1">
            <TextField
              className="lightInputFields"
              // id="idleTime"
              //disabled={true}
              label="Remarks"
              variant="filled"
              fullWidth
              //name="Idle/IHF Time"
              value={Remarks}
              onChange={handleRemarksChange}
            />
          </Grid>

          <Grid
            item
            xs={12}
            sm={3}
            className="d-flex jc-center width-100"
          ></Grid>
          <Grid
            item
            xs={12}
            sm={3}
            className="d-flex jc-center width-100"
          ></Grid>
          <Grid
            item
            xs={12}
            sm={3}
            className="d-flex jc-center width-100"
          ></Grid>
          <Grid
            item
            xs={12}
            sm={3}
            className="d-flex jc-center width-100"
          ></Grid>
          <Grid
            item
            xs={12}
            sm={3}
            className="d-flex jc-center width-100"
          ></Grid>
          <Grid
            item
            xs={12}
            sm={3}
            className="d-flex jc-center width-100"
          ></Grid>
          <Grid
            item
            xs={12}
            sm={4}
            className="d-flex jc-center width-100"
          ></Grid>

          {/*<Grid item xs={12} sm={3} className="d-flex jc-center width-100">*/}
          {/*    <Button className="
           *
           *
           *
           *    " onClick={calculateEfficiency}>*/}
          {/*        <span>Calculate Efficiency</span>*/}
          {/*    </Button>*/}
          {/*</Grid>*/}
          <Grid item xs={12} sm={2} className="d-flex jc-center width-100">
            <Button className="ns-btn-primary mt-1 mr-1" onClick={submitSlip}>
              <span>Save</span>
            </Button>
          </Grid>
          <Grid item xs={12} sm={2} className="d-flex jc-center width-100">
            <Button className="ns-btn-primary mt-1 mr-1" onClick={clear}>
              <span>Clear</span>
            </Button>
          </Grid>
          <Grid
            item
            xs={12}
            sm={3}
            className="d-flex jc-center width-100"
          ></Grid>
          <Grid
            item
            xs={12}
            sm={3}
            className="d-flex jc-center width-100"
          ></Grid>
          <Grid
            item
            xs={12}
            sm={3}
            className="d-flex jc-center width-100"
          ></Grid>
        </Grid>
        <Dialog
          open={openLoader}
          //onClose={handleClose}
          aria-labelledby="draggable-dialog-title"
          id="templateUploadSuccess"
          PaperProps={{
            style: {
              backgroundColor: "transparent",
              boxShadow: "none",
              borderColor: "transparent",
            },
          }}
        >
          <DialogContent>
            <CircularProgress />
          </DialogContent>
        </Dialog>
      </div>
    </ThemeProvider>
  );
}
